<template>
    <div
        id="app"
        class="font-sans"
    >
        <main-header
            :isGerman="isGerman"
            v-on:toggleLanguage="toggleLanguage()"
        ></main-header>
        <router-view />

        <!-- <div id="nav">
            <router-link to="/">Home</router-link> |
            <router-link to="/about">About</router-link>
        </div>
        <router-view /> -->
    </div>
</template>

<script>
import MainHeader from './components/MainHeader';

export default {
    components: {
        MainHeader,
    },
    props: {},
    data() {
        return {
            isGerman: true,
        };
    },
    methods: {
        toggleLanguage() {
            this.isGerman = !this.isGerman;
        }
    },
    created() { },
};
</script>
